import React from 'react';
import { Popover as PopoverAntd } from 'antd';

import { PopoverProps } from './model/popover.model';

import './popover.style.scss';

const Popover = ({ content, className, children, visible, handleVisibleChange }: PopoverProps) => {
  const handleVisible = visibleChange => handleVisibleChange(visibleChange);

  return (
    <div className='confirm-box'>
      <PopoverAntd
        trigger='click'
        visible={visible}
        onVisibleChange={handleVisible}
        content={content}
        overlayClassName={className}
        destroyTooltipOnHide>
        {children}
      </PopoverAntd>
    </div>
  );
};

export default Popover;
